// PRODUCT IMAGE SLIDER - Grid --------------------

function initSliders() {
  const sliders = document.querySelectorAll(
    ".product-image-slider-wrapper:not([data-slider-ready])"
  );

  sliders.forEach((slider) => {
    slider.dataset.sliderReady = "true";

    const images = Array.from(
      slider.querySelectorAll(".product-image-slide")
    );

    if (images.length === 0) return;

    const prevBtn = slider.querySelector(".custom-arrow.prev");
    const nextBtn = slider.querySelector(".custom-arrow.next");

    let index = 0;
    let timer = null;

    /* Show Image */
    const showImage = (i) => {
      images.forEach((img) => img.classList.remove("is-active"));
      images[i].classList.add("is-active");
    };

    showImage(0);

    /* Hover Auto Slide */
    slider.addEventListener("mouseenter", () => {
      if (images.length < 2) return;

      timer = setInterval(() => {
        index = (index + 1) % images.length;
        showImage(index);
      }, 1200);
    });

    slider.addEventListener("mouseleave", () => {
      clearInterval(timer);
      index = 0;
      showImage(0);
    });

    /* Manual Navigation — prevent link click */
    if (prevBtn) {
      prevBtn.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();   // prevents link redirect
        index = (index - 1 + images.length) % images.length;
        showImage(index);
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();   // prevents link redirect
        index = (index + 1) % images.length;
        showImage(index);
      });
    }
  });
}

document.addEventListener("DOMContentLoaded", () => {
  initSliders();
});

document.addEventListener("product-recommendations:loaded", () => {
  initSliders();
});

const sliderObserver = new MutationObserver(() => {
  initSliders();
});

sliderObserver.observe(document.body, {
  childList: true,
  subtree: true,
});


// Quick Add to cart Drawer ---------------

/* ============================================
   QUICK ADD DRAWER — FULL WORKING VERSION
   ============================================ */

// Global state
let qaProduct = null;
let qaVariant = null;

/* --------------------------------------------
   OPEN DRAWER FROM PRODUCT CARD
---------------------------------------------*/
function showQuickAddModal(handle) {
  fetch(`/products/${handle}.js`)
    .then(res => res.json())
    .then(product => {
      qaProduct = product;

      // Inject title + URL
      document.getElementById("drawerProductTitle").textContent = product.title;
      document.getElementById("drawerViewProduct").href = product.url;

      // Build sizes
      buildQuickAddSizes(product);

      // Select FIRST AVAILABLE variant
      qaVariant = product.variants.find(v => v.available) || product.variants[0];

      highlightActiveVariantButton();
      updateQuickAddPrice();

      // Reset qty
      document.getElementById("drawerQty").value = 1;

      // Open drawer
      document.getElementById("quickAddDrawer").classList.add("active");
    })
    .catch(err => console.error("Quick Add load error:", err));
}

/* --------------------------------------------
   BUILD SIZE BUTTONS (option1)
---------------------------------------------*/
function buildQuickAddSizes(product) {
  const container = document.getElementById("drawerOptions");
  container.innerHTML = "";

  const wrapper = document.createElement("div");
  wrapper.className = "drawer-option";

  wrapper.innerHTML = `<h4>Size</h4>`;
  const row = document.createElement("div");
  row.className = "option-row";

  product.variants.forEach(variant => {
    const btn = document.createElement("button");
    btn.className = "variant-btn";
    btn.textContent = variant.option1;

    if (!variant.available) {
      btn.classList.add("disabled");
      btn.disabled = true;
    }

    // Select size
    btn.addEventListener("click", () => {
      qaVariant = variant;
      highlightActiveVariantButton();
      updateQuickAddPrice();
    });

    row.appendChild(btn);
  });

  wrapper.appendChild(row);
  container.appendChild(wrapper);
}

/* --------------------------------------------
   HIGHLIGHT ACTIVE SIZE BUTTON
---------------------------------------------*/
function highlightActiveVariantButton() {
  document.querySelectorAll("#drawerOptions .variant-btn").forEach(btn => {
    btn.classList.remove("active");

    if (btn.textContent === qaVariant.option1) {
      btn.classList.add("active");
    }
  });
}

/* --------------------------------------------
   PRICE UPDATE
---------------------------------------------*/
function updateQuickAddPrice() {
  if (!qaVariant) return;

  const qty = parseInt(document.getElementById("drawerQty").value) || 1;
  const price = (qaVariant.price / 100) * qty;

  document.getElementById("drawerProductPrice").textContent =
    `Rs. ${price.toLocaleString("en-IN")}.00`;
}

/* --------------------------------------------
   QTY CHANGE
---------------------------------------------*/
function updateDrawerQty(change) {
  const input = document.getElementById("drawerQty");
  let value = parseInt(input.value) || 1;

  value += change;
  if (value < 1) value = 1;

  input.value = value;
  updateQuickAddPrice();
}

// Manual qty typing
document.addEventListener("DOMContentLoaded", () => {
  const qty = document.getElementById("drawerQty");
  if (qty) qty.addEventListener("change", updateQuickAddPrice);
});

/* --------------------------------------------
   ADD TO CART — FIXED + WORKING
---------------------------------------------*/
document.getElementById("drawerAddToCart").onclick = async function () {

  const atcBtn = this;

  if (!qaVariant) {
    atcBtn.innerHTML = "Select a size";
    return;
  }

  const variantId = qaVariant.id;
  const quantity = parseInt(document.getElementById("drawerQty").value) || 1;

  atcBtn.disabled = true;
  atcBtn.innerHTML = "Adding...";

  try {
    const res = await fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: variantId, quantity })
    });

    // Shopify error fallback
    if (!res.ok) {
      console.error("ATC Error:", await res.text());
      atcBtn.innerHTML = "Error — Try Again";
      atcBtn.disabled = false;
      return;
    }

    const data = await res.json();
    console.log("ATC SUCCESS:", data);

    /* -----------------------------------------
       1️⃣ Show success feedback
    ------------------------------------------*/
    atcBtn.innerHTML = "Added ✓";

    /* -----------------------------------------
       2️⃣ Update cart object manually (fallback)
    ------------------------------------------*/
    const cartRes = await fetch("/cart.js");
    const cartJson = await cartRes.json();
    window.Shopify = window.Shopify || {};
    window.Shopify.cart = cartJson;

    /* -----------------------------------------
       3️⃣ Fire ALL known theme cart refresh events
       (this ensures compatibility with ALL themes)
    ------------------------------------------*/
    document.dispatchEvent(new CustomEvent("theme:cart:update"));
    document.dispatchEvent(new CustomEvent("cart:updated"));
    document.dispatchEvent(new CustomEvent("cart:refresh"));
    document.dispatchEvent(new CustomEvent("reload-cart"));
    document.documentElement.dispatchEvent(new CustomEvent("cart:refresh"));

    /* -----------------------------------------
       4️⃣ Try opening cart drawer (Impulse/Prestige)
    ------------------------------------------*/
    document.dispatchEvent(
      new CustomEvent("cart:toggle", { detail: { open: true } })
    );

    /* -----------------------------------------
       5️⃣ Reset button after animation
    ------------------------------------------*/
    setTimeout(() => {
      atcBtn.innerHTML = "Add to Bag";
      atcBtn.disabled = false;
    }, 1400);

    /* -----------------------------------------
       6️⃣ Close quick add drawer
    ------------------------------------------*/
    closeQuickAddDrawer();

  } catch (err) {
    console.error("ATC Exception:", err);
    atcBtn.innerHTML = "Error — Try Again";
    atcBtn.disabled = false;
  }
};


/* --------------------------------------------
   CLOSE DRAWER
---------------------------------------------*/
function closeQuickAddDrawer() {
  document.getElementById("quickAddDrawer").classList.remove("active");
}


// View similar option - Single Product Page --------------------------

/* ============================================================
   VIEW SIMILAR DRAWER - FINAL CLEAN VERSION
============================================================ */

document.addEventListener("DOMContentLoaded", function () {
  const viewSimilarBtn = document.querySelector("#viewSimilarBtn");
  const drawer = document.querySelector("#similarDrawer");
  const container = document.querySelector("#similarProductsContainer");

  if (!viewSimilarBtn) {
    console.warn("⚠️ View Similar Btn not found");
    return;
  }

  console.log("View Similar button found:", viewSimilarBtn);

  const productId = viewSimilarBtn.dataset.productId;
  console.log("Product ID:", productId);

  /* ----------------------------------------------------------
     OPEN DRAWER & FETCH SIMILAR PRODUCTS
  ----------------------------------------------------------- */
  viewSimilarBtn.addEventListener("click", function () {
    if (!productId) return;

    console.log("Fetching:", `/recommendations/products.json?product_id=${productId}&limit=8`);

    fetch(`/recommendations/products.json?product_id=${productId}&limit=8`)
      .then((res) => res.json())
      .then((data) => {
        console.log("🟢 Recommendations received:", data);

        if (!data.products || data.products.length === 0) {
          container.innerHTML = "<p style='padding:20px;'>No similar products found.</p>";
        } else {
          renderSimilarProducts(data.products);
        }

        openSimilarDrawer();
      })
      .catch((err) => console.error("❌ Error fetching recommendations:", err));
  });

  /* ----------------------------------------------------------
     RENDER PRODUCTS INSIDE DRAWER
  ----------------------------------------------------------- */
  function renderSimilarProducts(products) {
    container.innerHTML = ""; // Clear previous

    products.forEach((p) => {
      const card = document.createElement("div");
      card.className = "similar-card";

      card.innerHTML = `
        <a href="${p.url}">
          <img src="${p.featured_image}" alt="${p.title}">
          <div class="similar-card-title">${p.title}</div>
          <div class="similar-card-price">Rs. ${p.price / 100}</div>
        </a>
      `;

      container.appendChild(card);
    });
  }

  /* ----------------------------------------------------------
     OPEN DRAWER
  ----------------------------------------------------------- */
  function openSimilarDrawer() {
    drawer.classList.add("open");
  }

  /* ----------------------------------------------------------
     CLOSE DRAWER (global function for close button)
  ----------------------------------------------------------- */
  window.closeSimilarDrawer = function () {
    drawer.classList.remove("open");
  };
});


// Product share New ---------------------
// Toggle the dropdown and icon on click
// ===== SHARE BUTTON (only runs if element exists) =====
const shareBtn = document.getElementById("shareBtn");
if (shareBtn) {
  shareBtn.addEventListener("click", function() {
    const dropdown = document.getElementById("dropdownContent");
    const shareIcon = document.getElementById("shareIcon");
    const shareDropdown = document.querySelector(".share-dropdown");

    dropdown.style.display = (dropdown.style.display === "block") ? "none" : "block";

    if (dropdown.style.display === "block") {
      shareIcon.src = "https://cdn.shopify.com/s/files/1/0563/8599/4892/files/icons8-close.svg?v=1765435242";
      shareDropdown.classList.add("open");
    } else {
      shareIcon.src = "https://cdn.shopify.com/s/files/1/0563/8599/4892/files/icons8-share.svg?v=1765435242";
      shareDropdown.classList.remove("open");
    }
  });
}

const copyLink = document.getElementById("copyLink");
if (copyLink) {
  copyLink.addEventListener("click", function() {
    const productUrl = window.location.href;
    navigator.clipboard.writeText(productUrl).then(() => {
      alert("Link copied to clipboard!");
    }).catch((error) => {
      console.error("Failed to copy: ", error);
    });
  });
}

// ===== MOBILE NAV ACCORDION =====
(function () {
  let navInitDone = false;
  let observer;

  // ---------------------------------------------------------------
  // EDIT HERE: destination links.
  // These menus are JS-driven slide-in panels, not real <a href> links,
  // so the browser can't "discover" a URL — it has to be told explicitly
  // (or it falls back to a guessed /collections/<slug>, see resolveHref).
  // ---------------------------------------------------------------

  // Top-level items: the ones rendered as <button aria-controls="...">
  const TOP_LEVEL_LINKS = {
    'Shirts': '/collections/shirts',
    'T-Shirts': '/collections/t-shirts',
    'Trousers': '/collections/trousers',
  };

  // Nested items: the ones rendered as <details><summary>text</summary>
  // Add every nested item under T-Shirts / Trousers here if its slug
  // guess (see resolveHref) wouldn't be correct.
  const NESTED_LINKS = {
    'Casual Shirt': '/collections/casual-wear',
    // 'Graphic Tee': '/collections/graphic-tee',
    // 'Chinos': '/collections/chinos',
  };

  // Which top-level items should start expanded on page load
  const OPEN_BY_DEFAULT = new Set(['Shirts']);

  const ARROW_SVG = (size) => `
    <svg fill="none" width="${size}" viewBox="0 0 10 10">
      <path d="M1 3l4 4 4-4" stroke="currentColor" stroke-linecap="square"/>
    </svg>`;

  function slugify(text) {
    return text
      .toLowerCase()
      .trim()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/(^-|-$)/g, '');
  }

  function resolveHref(map, text) {
    if (map[text]) return map[text];
    return '/collections/' + slugify(text);
  }

  function createArrowButton(size, padding, onToggle) {
    const arrow = document.createElement('button');
    arrow.type = 'button';
    arrow.setAttribute('aria-label', 'Toggle submenu');
    arrow.innerHTML = ARROW_SVG(size);
    arrow.style.cssText = `background:none;border:none;cursor:pointer;padding:${padding};flex-shrink:0;transition:transform .3s;`;
    arrow.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      onToggle(arrow);
    });
    return arrow;
  }

  function setArrowOpen(arrow, isOpen) {
    arrow.style.transform = isOpen ? 'rotate(180deg)' : 'rotate(0deg)';
  }

  function ensureMarkerResetStyle() {
    if (document.getElementById('mobile-nav-marker-reset')) return;
    const styleTag = document.createElement('style');
    styleTag.id = 'mobile-nav-marker-reset';
    styleTag.textContent = `
      .js-mobile-inline-submenu summary { list-style: none; }
      .js-mobile-inline-submenu summary::-webkit-details-marker { display: none; }
      .js-mobile-inline-submenu summary::before,
      .js-mobile-inline-submenu summary::after { content: none !important; display: none !important; }
    `;
    document.head.appendChild(styleTag);
  }

  // Converts one nested <details> row (e.g. "Casual Shirt") into a real
  // text link + a separate arrow button with its own tap area.
  function convertNestedDetail(detail) {
    const summary = detail.querySelector('summary');
    const textNode = summary && [...summary.childNodes].find(
      (n) => n.nodeType === Node.TEXT_NODE && n.textContent.trim()
    );
    if (!textNode) return;

    const text = textNode.textContent.trim();
    textNode.textContent = '';

    // Real DOM icon nodes the theme injects (e.g. <span aria-hidden="true">) —
    // not CSS pseudo-elements, so they must be removed directly.
    summary.querySelectorAll('[aria-hidden="true"]').forEach((el) => el.remove());
    summary.style.cssText += ';display:flex;align-items:center;justify-content:space-between;width:100%;cursor:default;';

    const innerLink = document.createElement('a');
    innerLink.href = resolveHref(NESTED_LINKS, text);
    innerLink.textContent = text;
    innerLink.className = summary.className;
    innerLink.style.cssText = 'flex:1;text-decoration:none;color:inherit;padding:0;';
    innerLink.addEventListener('click', (e) => e.stopPropagation()); // don't trigger native toggle

    const innerArrow = createArrowButton(10, '8px 12px', () => {
      detail.open = !detail.open;
      setArrowOpen(innerArrow, detail.open);
      detail.dispatchEvent(new Event('toggle'));
    });
    setArrowOpen(innerArrow, detail.open);

    summary.append(innerLink, innerArrow);
  }

  // Converts one top-level drill-down button (Shirts / T-Shirts / Trousers)
  // into a text link + separate arrow toggle, with an inline cloned submenu.
  function convertTopLevelItem(btn) {
    const panel = document.getElementById(btn.getAttribute('aria-controls'));
    const subList = panel?.querySelector('.header-sidebar__linklist');
    const parentLi = btn.closest('li');
    if (!panel || !subList || !parentLi) return;

    const text = btn.childNodes[0].textContent.trim();

    // --- top-level row: link + chevron ---
    const wrapper = document.createElement('div');
    wrapper.style.cssText = 'display:flex;align-items:center;justify-content:space-between;width:100%;';

    const link = document.createElement('a');
    link.href = resolveHref(TOP_LEVEL_LINKS, text);
    link.className = btn.className;
    link.textContent = text;
    link.style.flex = '1';

    let isOpen = OPEN_BY_DEFAULT.has(text);

    // --- collapsible wrapper: CSS Grid 0fr/1fr trick ---
    // A single-row grid whose row track animates between 0fr (collapsed)
    // and 1fr (content's natural height). No JS measurement of height is
    // ever needed — the browser recalculates the true content height on
    // every layout pass, including later font swaps, image loads, or a
    // nested <details> expanding — so there's nothing to get out of sync
    // and no "one click behind" possibility.
    const collapse = document.createElement('div');
    collapse.style.cssText = `display:grid;grid-template-rows:${isOpen ? '1fr' : '0fr'};transition:grid-template-rows .3s ease;`;

    // --- inline (cloned) submenu: the single grid row/item ---
    const inlineList = document.createElement('ul');
    inlineList.className = subList.className + ' js-mobile-inline-submenu'; // scoped, doesn't touch original menu
    inlineList.style.cssText = 'padding-left:16px;overflow:hidden;min-height:0;';
    inlineList.innerHTML = subList.innerHTML;

    const chevron = createArrowButton(12, '0 12px', () => {
      isOpen = !isOpen;
      collapse.style.gridTemplateRows = isOpen ? '1fr' : '0fr';
      setArrowOpen(chevron, isOpen);
    });

    wrapper.append(link, chevron);
    btn.replaceWith(wrapper);

    ensureMarkerResetStyle();

    // Rebuild every nested <details> row found inside this menu's submenu
    inlineList.querySelectorAll('details').forEach(convertNestedDetail);

    collapse.appendChild(inlineList);
    parentLi.appendChild(collapse);
    panel.setAttribute('hidden', '');

    setArrowOpen(chevron, isOpen);
  }

  function initMobileNav() {
    if (navInitDone) return;

    // Grab ALL top-level drill-down buttons (Shirts, T-Shirts, Trousers, ...)
    // instead of just the first match.
    const buttons = Array.from(
      document.querySelectorAll('.header-sidebar__main-panel button[aria-controls]')
    );
    if (!buttons.length) return;

    navInitDone = true;
    observer?.disconnect();

    buttons.forEach(convertTopLevelItem);
  }

  observer = new MutationObserver(() => {
    const style = document.querySelector('.header-sidebar__main-panel')?.getAttribute('style');
    if (style?.includes('opacity: 0')) initMobileNav();
  });

  observer.observe(document.querySelector('header-sidebar') || document.body, {
    attributes: true,
    subtree: true,
    attributeFilter: ['style'],
  });
})();